import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Loader from "../components/Loader";
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
import SuperAdminGuard from "../guards/SuperAdminGuard";
import AdminLayout from "../pages/Admin/Layout/AdminLayout";
import WebsiteLayout from "../pages/Website/Layout/Layout";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "/app/about-us",
      element: (
        <GuestGuard>
          <AboutUs />
        </GuestGuard>
      ),
    },
    {
      path: "/app/contact-us",
      element: (
        <GuestGuard>
          <ContactUs />
        </GuestGuard>
      ),
    },
    {
      path: "/app/privacy-policy",
      element: (
        <GuestGuard>
          <PrivacyPolicy />
        </GuestGuard>
      ),
    },
    {
      path: "/app/terms-and-conditions",
      element: (
        <GuestGuard>
          <TermsAndConditions />
        </GuestGuard>
      ),
    },
    {
      path: "/app/cancellation-and-refund",
      element: (
        <GuestGuard>
          <CancellationRefund />
        </GuestGuard>
      ),
    },
    {
      path: "/",
      element: (
        <GuestGuard>
          <WebsiteLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: "/",
          element: (
            <GuestGuard>
              <LandingPage />
            </GuestGuard>
          ),
        },
        {
          path: "/search",
          element: (
            <GuestGuard>
              <Search />
            </GuestGuard>
          ),
        },
        {
          path: "/gallery",
          element: (
            <GuestGuard>
              <ImageGallery />
            </GuestGuard>
          ),
        },
        {
          path: "/all-package-tests",
          element: (
            <GuestGuard>
              <AllPackageTest />
            </GuestGuard>
          ),
        },
        {
          path: "/all-Individual-tests",
          element: (
            <GuestGuard>
              <AllNormalTest />
            </GuestGuard>
          ),
        },
        {
          path: "/bookings",
          element: (
            <GuestGuard>
              <AllBookings />
            </GuestGuard>
          ),
        },
        {
          path: "/prescription",
          element: (
            <GuestGuard>
              <UploadPrescription />
            </GuestGuard>
          ),
        },
        {
          path: "/view-reports",
          element: (
            <GuestGuard>
              <ReportViewer />
            </GuestGuard>
          ),
        },
        {
          path: "/reports",
          element: (
            <GuestGuard>
              <Reports />
            </GuestGuard>
          ),
        },
        {
          path: "/view-bills",
          element: (
            <GuestGuard>
              <BillViewer />
            </GuestGuard>
          ),
        },
        {
          path: "/about-us",
          element: (
            <GuestGuard>
              <AboutUs />
            </GuestGuard>
          ),
        },
        {
          path: "/contact-us",
          element: (
            <GuestGuard>
              <ContactUs />
            </GuestGuard>
          ),
        },
        {
          path: "/careers",
          element: (
            <GuestGuard>
              <Careers />
            </GuestGuard>
          ),
        },
        {
          path: "/corporate-wellness",
          element: (
            <GuestGuard>
              <CorporateWellness />
            </GuestGuard>
          ),
        },
        {
          path: "/profile",
          element: (
            <GuestGuard>
              <PatientProfilePage />
            </GuestGuard>
          ),
        },
        {
          path: "/privacy-policy",
          element: (
            <GuestGuard>
              <PrivacyPolicy />
            </GuestGuard>
          ),
        },
        {
          path: "/terms-and-conditions",
          element: (
            <GuestGuard>
              <TermsAndConditions />
            </GuestGuard>
          ),
        },
        {
          path: "/cancellation-and-refund",
          element: (
            <GuestGuard>
              <CancellationRefund />
            </GuestGuard>
          ),
        },
        {
          path: "/blogs",
          element: (
            <GuestGuard>
              <BlogPage />
            </GuestGuard>
          ),
        },
        {
          path: "/blog/:slug",
          element: (
            <GuestGuard>
              <BlogDetail />
            </GuestGuard>
          ),
        },
        {
          path: "/services",
          element: (
            <GuestGuard>
              <ServiceList />
            </GuestGuard>
          ),
        },
        {
          path: "/services/:slug",
          element: (
            <GuestGuard>
              <ServicePage />
            </GuestGuard>
          ),
        },
        {
          path: "/branch/:branchName",
          element: (
            <GuestGuard>
              <BranchDetail />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: "/login",
      element: (
        <GuestGuard>
          <AuthPage mode="login" />
        </GuestGuard>
      ),
    },
    {
      path: "/book-your-appointment",
      element: (
          <AuthPage mode="register" />
      ),
    },
    {
      path: "/adminlogin",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "/admin-blog-view/:slug",
      element: (
        <AuthGuard>
          <SuperAdminGuard requiredPermission="blogs">
            <BlogDetail />
          </SuperAdminGuard>
        </AuthGuard>
      ),
    },
    {
      path: "/admin-service-view/:slug",
      element: (
        <AuthGuard>
          <SuperAdminGuard requiredPermission="services">
            <ServicePage />
          </SuperAdminGuard>
        </AuthGuard>
      ),
    },
    {
      path: "/admin",
      element: (
        <AuthGuard>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/admin/dashboard",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="dashboard">
                <Dashboard />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/profileTest",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="packageTest">
                <ProfileTest />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-profileTest",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="packageTest">
                <AddProfileTest />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-profileTest",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="packageTest">
                <EditProfileTest />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/testlist",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="individualTest">
                <TestList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-testlist",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="individualTest">
                <AddTestList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-testlist",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="individualTest">
                <EditTestList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/banners",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="banners">
                <Banner />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-banner",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="banner">
                <AddBanner />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-banner",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="banner">
                <EditBanner />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/bookings",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="bookings">
                <Bookings />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/patients",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="patients">
                <Patients />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-patients",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="patients">
                <AddPatients />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-patients",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="patients">
                <EditPatients />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/admin-list",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="adminList">
                <AdminList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-admin-list",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="adminList">
                <AddAdminList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-admin-list",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="adminList">
                <EditAdminList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/testimonial",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="testimonial">
                <Testimonial />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-testimonial",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="testimonial">
                <AddTestimonial />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-testimonial",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="testimonial">
                <EditTestimonial />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/enquiry",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="enquiry">
                <Enquiry />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-enquiry",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="enquiry">
                <EditEnquiry />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/faq",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="faq">
                <Faq />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-faq",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="faq">
                <AddFaq />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-faq",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="faq">
                <EditFaq />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-category",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="faq">
                <AddCategory />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-category",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="faq">
                <EditCategory />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/issues",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="issues&complaints">
                <Issues />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-issues",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="issues&complaints">
                <EditIssues />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/notifications",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="notification">
                <Notifications />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-notification",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="notification">
                <AddNotification />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/team",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="team">
                <Team />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-team",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="team">
                <AddTeam />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-team",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="team">
                <EditTeam />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/blogs",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <BlogList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-blog-v2",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <AddBlogV2 />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        // REMOVED LEGACY EDIT BLOG
        {
          path: "/admin/edit-blog-v2",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <EditBlogV2 />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/service-page",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="services">
                {" "}
                {/* Assuming permission blogs or creating new one */}
                <ServicePageList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-service-page",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="services">
                <AddServicePage />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-service-page",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="services">
                <EditServicePage />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/services/:slug",
          element: (
            <GuestGuard>
              <ServicePage requiredPermission="services" />
            </GuestGuard>
          ),
        },
        {
          path: "/admin/blog-tags",

          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <BlogTagList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-blog-tag",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <AddBlogTag />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-blog-tag",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <EditBlogTag />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/blog-category",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <BlogCategoryList />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-blog-category",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <AddBlogCategory />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-blog-category",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="blogs">
                <EditBlogCategory />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/prescription",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="prescription">
                <Prescription />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/branches",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="branches">
                <Branches />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-branches",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="branches">
                <AddBranches />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-branches",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="branches">
                <EditBranches />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/settings",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="settings">
                <Settings />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/career-applications",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="careers">
                <CareerApplications />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/view-career-application",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="careers">
                <ViewCareerApplication />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-career-application",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="careers">
                <EditCareerApplication />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/logs",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="logs">
                <Logs />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admin/log-detail/:id",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="logs">
                <LogDetail />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      children: [
        // { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ]);
}

// const NotFound = Loadable(lazy(() => import("../pages/404/Page404")));

//=====================WEBSITE===============

const LandingPage = Loadable(
  lazy(() => import("../pages/Website/LandingPage/LandingPage")),
);
const AllPackageTest = Loadable(
  lazy(() => import("../pages/Website/AllPackageTest/AllPackageTest")),
);
const AllNormalTest = Loadable(
  lazy(() => import("../pages/Website/AllNormalTest/AllNormalTest")),
);
const AllBookings = Loadable(
  lazy(() => import("../pages/Website/AllBookings/AllBookings")),
);
const UploadPrescription = Loadable(
  lazy(() => import("../pages/Website/Prescription/Prescription")),
);
const ReportViewer = Loadable(
  lazy(() => import("../pages/Website/ReportViewer/ReportViewer")),
);
const Reports = Loadable(
  lazy(() => import("../pages/Website/Reports/Reports")),
);
const BillViewer = Loadable(
  lazy(() => import("../pages/Website/BillViewer/BillViewer")),
);
const AboutUs = Loadable(
  lazy(() => import("../pages/Website/AboutusPage/Aboutus")),
);
const ImageGallery = Loadable(
  lazy(() => import("../pages/Website/HealthcareGallery/ImageGallery")),
);
const ContactUs = Loadable(
  lazy(() => import("../pages/Website/ContactUs/ContactUs")),
);
const Careers = Loadable(
  lazy(() => import("../pages/Website/Careers/Careers")),
);
const CorporateWellness = Loadable(
  lazy(() => import("../pages/Website/CorporateWellness/CorporateWellness")),
);
const PatientProfilePage = Loadable(
  lazy(() => import("../pages/Website/PatientProfilePage/PatientProfilePage")),
);
const PrivacyPolicy = Loadable(
  lazy(() => import("../pages/Website/PrivacyPolicy/PrivacyPolicy")),
);
const TermsAndConditions = Loadable(
  lazy(() => import("../pages/Website/TermsAndConditions/TermsAndConditions")),
);
const CancellationRefund = Loadable(
  lazy(() => import("../pages/Website/CancellationRefund/CancellationRefund")),
);
const Search = Loadable(
  lazy(() => import("../pages/Website/SearchPage/SearchScreen")),
);
const BlogPage = Loadable(lazy(() => import("../pages/Website/Blog/BlogPage")));
const BlogDetail = Loadable(
  lazy(() => import("../pages/Website/Blog/BlogDetail")),
);
const ServicePage = Loadable(
  lazy(() => import("../pages/Website/ServicePage/ServicePage")),
);
const ServiceList = Loadable(
  lazy(() => import("../pages/Website/ServicePage/ServiceList")),
);
const BranchDetail = Loadable(
  lazy(() => import("../pages/Website/BranchDetail/BranchDetail")),
);

const AuthPage = Loadable(
  lazy(() => import("../pages/Website/Authentication/AuthPage")),
);
//====================ADMIN===================
const Login = Loadable(lazy(() => import("../pages/Admin/LoginForms/Login")));

const Dashboard = Loadable(
  lazy(() => import("../pages/Admin/Dashboard/Dashboard")),
);

const TestList = Loadable(
  lazy(() => import("../pages/Admin/TestList/TestList")),
);
const AddTestList = Loadable(
  lazy(() => import("../pages/Admin/TestList/AddTestList")),
);
const EditTestList = Loadable(
  lazy(() => import("../pages/Admin/TestList/EditTestList ")),
);
const ProfileTest = Loadable(
  lazy(() => import("../pages/Admin/ProfileTest/ProfileTest")),
);
const AddProfileTest = Loadable(
  lazy(() => import("../pages/Admin/ProfileTest/AddProfileTest")),
);
const EditProfileTest = Loadable(
  lazy(() => import("../pages/Admin/ProfileTest/EditProfileTest")),
);
const Patients = Loadable(
  lazy(() => import("../pages/Admin/Patients/Patients")),
);
const AddPatients = Loadable(
  lazy(() => import("../pages/Admin/Patients/AddPatients")),
);
const EditPatients = Loadable(
  lazy(() => import("../pages/Admin/Patients/EditPatients")),
);
const Banner = Loadable(lazy(() => import("../pages/Admin/Banner/Banner")));
const AddBanner = Loadable(
  lazy(() => import("../pages/Admin/Banner/AddBanner")),
);
const EditBanner = Loadable(
  lazy(() => import("../pages/Admin/Banner/EditBanner")),
);
const Bookings = Loadable(
  lazy(() => import("../pages/Admin/Bookings/Bookings")),
);
const AdminList = Loadable(
  lazy(() => import("../pages/Admin/AdminList/AdminList")),
);
const AddAdminList = Loadable(
  lazy(() => import("../pages/Admin/AdminList/AddAdminList")),
);
const EditAdminList = Loadable(
  lazy(() => import("../pages/Admin/AdminList/EditAdminList")),
);
const Testimonial = Loadable(
  lazy(() => import("../pages/Admin/Testimonial/Testimonial")),
);
const AddTestimonial = Loadable(
  lazy(() => import("../pages/Admin/Testimonial/AddTestimonial")),
);
const EditTestimonial = Loadable(
  lazy(() => import("../pages/Admin/Testimonial/EditTestimonial")),
);
const Enquiry = Loadable(lazy(() => import("../pages/Admin/Enquiry/Enquiry")));
const EditEnquiry = Loadable(
  lazy(() => import("../pages/Admin/Enquiry/EditEnquiry")),
);
const Faq = Loadable(lazy(() => import("../pages/Admin/FAQ/Faq")));
const AddFaq = Loadable(lazy(() => import("../pages/Admin/FAQ/AddFaq")));
const EditFaq = Loadable(lazy(() => import("../pages/Admin/FAQ/EditFAQ")));
const Issues = Loadable(
  lazy(() => import("../pages/Admin/Issues&Complaints/Issues")),
);
const EditIssues = Loadable(
  lazy(() => import("../pages/Admin/Issues&Complaints/EditIssues")),
);
const AddCategory = Loadable(
  lazy(() => import("../pages/Admin/FAQ_Category/AddCategory")),
);
const EditCategory = Loadable(
  lazy(() => import("../pages/Admin/FAQ_Category/EditCategory")),
);
const Notifications = Loadable(
  lazy(() => import("../pages/Admin/Notifications/Notifications")),
);
const AddNotification = Loadable(
  lazy(() => import("../pages/Admin/Notifications/AddNotification")),
);
const Team = Loadable(lazy(() => import("../pages/Admin/Team/Team")));
const AddTeam = Loadable(lazy(() => import("../pages/Admin/Team/AddTeam")));
const EditTeam = Loadable(lazy(() => import("../pages/Admin/Team/EditTeam")));
const BlogList = Loadable(lazy(() => import("../pages/Admin/Blogs/BlogLists")));
const AddBlogV2 = Loadable(
  lazy(() => import("../pages/Admin/Blogs/AddBlogV2")),
);
const EditBlogV2 = Loadable(
  lazy(() => import("../pages/Admin/Blogs/EditBlogV2")),
);
// LEGACY BLOG COMPONENTS REMOVED
const ServicePageList = Loadable(
  lazy(() => import("../pages/Admin/ServicePage/ServicePageList")),
);
const AddServicePage = Loadable(
  lazy(() => import("../pages/Admin/ServicePage/AddServicePage")),
);
const EditServicePage = Loadable(
  lazy(() => import("../pages/Admin/ServicePage/EditServicePage")),
);
const BlogTagList = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Tags/TagList")),
);
const AddBlogTag = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Tags/AddTag")),
);
const EditBlogTag = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Tags/EditTag")),
);
const BlogCategoryList = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Category/CategoryList")),
);
const AddBlogCategory = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Category/AddCategory")),
);
const EditBlogCategory = Loadable(
  lazy(() => import("../pages/Admin/Blogs/Category/EditCategory")),
);

const Prescription = Loadable(
  lazy(() => import("../pages/Admin/Prescription/Prescription")),
);
const Branches = Loadable(
  lazy(() => import("../pages/Admin/Branches/Branches")),
);
const AddBranches = Loadable(
  lazy(() => import("../pages/Admin/Branches/AddBranches")),
);
const EditBranches = Loadable(
  lazy(() => import("../pages/Admin/Branches/EditBranches")),
);
const Settings = Loadable(
  lazy(() => import("../pages/Admin/Settings/Settings")),
);

const CareerApplications = Loadable(
  lazy(() => import("../pages/Admin/Careers/CareerApplications")),
);
const ViewCareerApplication = Loadable(
  lazy(() => import("../pages/Admin/Careers/ViewCareerApplication")),
);
const EditCareerApplication = Loadable(
  lazy(() => import("../pages/Admin/Careers/EditCareerApplication")),
);
const Logs = Loadable(lazy(() => import("../pages/Admin/Logs/Logs")));
const LogDetail = Loadable(lazy(() => import("../pages/Admin/Logs/LogDetail")));
